import { z } from 'zod';

export const itemRoadmapDTOSchema = z.object({
  roadmapId: z.number().int(),
  name: z.string(),
  ownerId: z.string().nullable(),
  createdAt: z.iso.datetime(),
});

export type ItemRoadmapDTO = z.infer<typeof itemRoadmapDTOSchema>;
